export const mockRooms = [
  {
    title: "Deluxe Bungalow (Mountain View)",
    slug: "deluxe-bungalow-mountain-view",
    image: "/media/rooms/deluxe-bungalow/deluxe-bungalow (5).webp",
    description: "This bungalow features a infinity pool. Featuring a private entrance, this air-conditioned bungalow consists of 1 living room, 1 separate bedroom and 1 bathroom with a shower and a hairdryer. The bungalow is furnished with a desk and a seating area and provides a mini-bar, a tea and coffee maker and garden views. The unit offers 1 bed.",
    features: ["Infinity Pool", "Mountain View", "Private Balcony"],
    amenities: [
      "Desk", "Carbon monoxide detector", "Safety deposit box", "Wake-up service", 
      "Wake-up service/Alarm clock", "Sofa", "Alarm clock", "Iron", "Drying rack for clothing", 
      "Towels", "Ironing facilities", "Seating area", "Socket near the bed", 
      "Tea/Coffee maker", "Linens", "Minibar", "Private entrance", 
      "Electric kettle", "Single-room AC for guest accommodation", "Dryer", "Wardrobe or closet", 
      "Mosquito net", "Air conditioning", "Clothes rack", "Hand sanitizer"
    ],
    inclusions: [
      "Breakfast",
      "2 Bottle Mineral Water Free Refillable",
      "Free Tea Time",
      "Free Massage 15 Minutes each Guest",
      "Free Fruit Basket"
    ],
    noted: [
      "Additional surcharge for High Season 15% from each rate",
      "Additional surcharge for Peak Season 15% from each rate",
      "Extra bed rate IDR 350.000 (includes 21% tax & service)",
      "Include breakfast",
      "Pool package (outside guest) - IDR 250.000 nett",
      "Inclusion meal, drink, towel"
    ],
    roomSize: "50 sqm",
    bedSize: "1 Queen Bed",
    view: "Garden, Pool, Mountain, Landmark & River View",
    roomRules: "Smoking: No smoking. Quiet hours after 10 PM. Check-in at 2 PM, Check-out at 12 PM.",
    gallery: [
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (1).webp",
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (2).webp",
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (3).webp",
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (4).webp",
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (5).webp",
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (1).webp",
      "/media/rooms/deluxe-bungalow/deluxe-bungalow (2).webp",
    ],
    price: "IDR 800.000 / Night"
  },
  {
    title: "Suite Room (Mountain View)",
    slug: "suite-room-mountain-view",
    image: "/media/rooms/suite-room/suite-room (2).webp",
    description: "Guests will have a special experience as this suite offers a pool with a view. Featuring a private entrance, this spacious suite also is consisted of of 1 bedroom, a seating area and 1 bathroom with a shower and a hairdryer. The unit features air conditioning, garden views, a terrace and wine/champagne is featured for guests. The unit offers 1 bed.",
    features: ["Private Pool", "Mount Agung View", "Living Room"],
    amenities: [
      "Desk", "Carbon monoxide detector", "Safety deposit box", "Wake-up service", 
      "Sofa", "Alarm clock", "Iron", "Drying rack for clothing", "Towels", 
      "Ironing facilities", "Seating area", "Socket near the bed", "Tea/Coffee maker", 
      "Private pool", "Refrigerator", "Linens", "Minibar", "Private entrance", 
      "Electric kettle", "Air conditioning", "Dryer", "Wardrobe or closet", 
      "Clothes rack", "Hand sanitizer"
    ],
    inclusions: [
      "Breakfast",
      "2 Bottle Mineral Water Free Refillable",
      "Free Tea Time",
      "Free Massage 15 Minutes each Guest",
      "Free Fruit Basket"
    ],
    noted: [
      "Additional surcharge for High Season 15% from each rate",
      "Additional surcharge for Peak Season 15% from each rate",
      "Extra bed rate IDR 350.000 (includes 21% tax & service)",
      "Include breakfast",
      "Pool package (outside guest) - IDR 250.000 nett",
      "Inclusion meal, drink, towel"
    ],
    roomSize: "100 sqm",
    bedSize: "1 Queen Bed",
    view: "Mountain, River, Landmark, Pool & Garden View",
    roomRules: "Smoking: No smoking. Quiet hours after 10 PM. Check-in at 2 PM, Check-out at 12 PM.",
    gallery: [
      "/media/rooms/suite-room/suite-room (1).webp",
      "/media/rooms/suite-room/suite-room (2).webp",
      "/media/rooms/suite-room/suite-room (3).webp",
      "/media/rooms/suite-room/suite-room (4).webp",
      "/media/rooms/suite-room/suite-room (5).webp",
      "/media/rooms/suite-room/suite-room (6).webp",
      "/media/rooms/suite-room/suite-room (7).webp",
      "/media/rooms/suite-room/suite-room (2).webp",
      "/media/rooms/suite-room/suite-room (4).webp",
      "/media/rooms/suite-room/suite-room (5).webp",
      "/media/rooms/suite-room/suite-room (3).webp",
      "/media/rooms/suite-room/suite-room (1).webp"
    ],
    price: "IDR 1.200.000 / Night"
  },
  {
    title: "Private Pool Villa (Mountain View)",
    slug: "private-pool-villa-mountain-view",
    image: "/media/rooms/private-pool-villa/private-pool-villa (1).webp",
    description: "This villa features a pool with a view. Featuring a private entrance, this air-conditioned villa consists of 1 living room, 1 separate bedroom and 1 bathroom with a bath and a shower. The spacious villa provides a mini-bar, a tea and coffee maker, a seating area as well as a terrace with garden views. The unit offers 1 bed.",
    features: ["Private Pool", "Nature View", "Bedroom"],
    amenities: [
      "Desk", "Carbon monoxide detector", "Safety deposit box", "Dining table", 
      "Wake-up service", "Sofa", "Alarm clock", "Iron", "Drying rack for clothing", 
      "Towels", "Ironing facilities", "Seating area", "Socket near the bed", 
      "Tea/Coffee maker", "Private pool", "Refrigerator", "Linens", "Minibar", 
      "Tile/Marble floor", "Private entrance", "Electric kettle", "Air conditioning", 
      "Dryer", "Wardrobe or closet", "Mosquito net", "Dining area", "Clothes rack", 
      "Hand sanitizer"
    ],
    inclusions: [
      "Breakfast",
      "2 Bottle Mineral Water Free Refillable",
      "Free Tea Time",
      "Free Massage 15 Minutes each Guest",
      "Free Fruit Basket"
    ],
    noted: [
      "Additional surcharge for High Season 15% from each rate",
      "Additional surcharge for Peak Season 15% from each rate",
      "Extra bed rate IDR 350.000 (includes 21% tax & service)",
      "Include breakfast",
      "Pool package (outside guest) - IDR 250.000 nett",
      "Inclusion meal, drink, towel"
    ],
    roomSize: "250 sqm",
    bedSize: "1 King Bed",
    view: "Mountain, River, Landmark, Pool & Garden View",
    roomRules: "Smoking: No smoking. Quiet hours after 10 PM. Check-in at 2 PM, Check-out at 12 PM.",
    gallery: [
      "/media/rooms/private-pool-villa/private-pool-villa (1).webp",
      "/media/rooms/private-pool-villa/private-pool-villa (2).webp",
      "/media/rooms/private-pool-villa/private-pool-villa-night-scene-1.webp",
      "/media/rooms/private-pool-villa/private-pool-villa-night-scene-2.webp",
      "/media/rooms/private-pool-villa/private-pool-villa-night-scene-3.webp"
    ],
    price: "IDR 1.500.000 / Night"
  }
];
